//////// EAEF 1_5 schema
const oneFiveSchema = {
  title: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
  addAPI: "cat1_5AddEmissionActivityAPI",
  cat: "cat1_5",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
  ],
};

export default oneFiveSchema;
